import { render, staticRenderFns } from "./SummaryOverview.vue?vue&type=template&id=27f27e7b&scoped=true&"
import script from "./SummaryOverview.vue?vue&type=script&lang=js&"
export * from "./SummaryOverview.vue?vue&type=script&lang=js&"
import style0 from "./SummaryOverview.vue?vue&type=style&index=0&id=27f27e7b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27f27e7b",
  null
  
)

export default component.exports